export default {
  UPDATE_QANDA_EMAIL_TEMPLATE: 'UPDATE_QANDA_EMAIL_TEMPLATE',
  SAVE_QANDA_EMAIL_TEMPLATE_REQUEST: (identifier = '') => `SAVE_QANDA_EMAIL_TEMPLATE_REQUEST_${identifier.toUpperCase()}`,
  SAVE_QANDA_EMAIL_TEMPLATE_SUCCESS: (identifier = '') => `SAVE_QANDA_EMAIL_TEMPLATE_SUCCESS_${identifier.toUpperCase()}`,
  SAVE_QANDA_EMAIL_TEMPLATE_FAILURE: (identifier = '') => `SAVE_QANDA_EMAIL_TEMPLATE_FAILURE_${identifier.toUpperCase()}`
}
